import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { HomePage } from "../home/home";

import { GooglePlus } from "@ionic-native/google-plus";
import { Platform } from "ionic-angular";

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})

export class LoginPage {
  constructor
    (
    public navCtrl: NavController,
    public navParams: NavParams,
    private googlePlus: GooglePlus,
    private platform: Platform
    ) {

  }

  doLogin() {
    this.navCtrl.push(HomePage);
  };

  loginUser() {
    if (this.platform.ready().
      then((e) => {
        console.dir(e);
      }))

      if (this.platform.is("ios")) {
        console.log("iOS");
      }

    if (this.platform.is("cordova")) {
      console.log("Cordova");
    }

    if (this.platform.is("core")) {
      console.log("Core");
    }

    if (this.platform.is("mobile")) {
      console.log("Mobile");
    }

    if (this.platform.is("mobileweb")) {
      console.log("Mobile Web");
    }

    if (this.platform.is("windows")) {
      console.log("Windows");
    }

    this.googlePlus.login({
      "webClientId": "462655363816-oj9tbq7r3rg31eprtt4uoj5lqte3h04t.apps.googleusercontent.com",
      "offline": true
    }).
      then(res => console.dir(res)).
      catch(err => console.dir(err));
  };
}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts